import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=0f7a1dbb&scoped=true&"
import script from "./_slug.vue?vue&type=script&lang=ts&"
export * from "./_slug.vue?vue&type=script&lang=ts&"
import style0 from "./_slug.vue?vue&type=style&index=0&id=0f7a1dbb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7a1dbb",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogAcfBlocks: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/blog/BlogAcfBlocks.vue').default})
